import "leaflet/dist/leaflet.css";

import * as React from "react";
import { ReactNode, useEffect, useState } from "react";

import coordinates from "./coordinates.json";
import Legend from "./Legend/Legend";

const MapView = () => {
  const [Component, setComponent] = useState<ReactNode>(<></>);
  const center = [41.653681, -0.8711];
  useEffect(() => {
    import("react-leaflet").then(({ MapContainer, Polygon, TileLayer }) => {
      // Aquí puedes usar MapContainer, Polygon, TileLayer
      const monasteryArea = { color: "var(--c-purple)" };
      const fundationArea = { color: "var(--c-secondary)", fillColor: "var(--c-secondary)", fillOpacity: 1 };
      setComponent(
        <MapContainer center={center} zoom={17}>
          <TileLayer
            attribution="&copy; Cartocdn"
            // url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}.jpg"
            url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.jpg"
          />
          <Polygon pathOptions={fundationArea} positions={coordinates.interiorSpace} />
          <Polygon pathOptions={monasteryArea} positions={coordinates.indoorArea} />
          <Legend />
        </MapContainer>,
      );
    });
  }, []);

  return Component;
};

export default MapView;
